import {Component} from 'preact'
import style from './style.scss'
import NavLeft from '/chat/src/components/SVGImages/NavLeft'
import NavRight from '/chat/src/components/SVGImages/NavRight'

class NavButton extends Component{
    constructor(props) {
        super(props)
        this.state = {
            isHovered: false
        }
    }
    render() {
        const {display, onClick, direction, color} = this.props;
        const directionStyle = direction === 'left' ? style.LeftNav : style.RightNav;
        const arrowColor = this.state.isHovered ? this.props.color : '#e5e5e5'
        const arrow = direction === 'left' ? <NavLeft color={arrowColor}/> : <NavRight color={arrowColor}/>
        if (display) {
            return <div
                    onMouseEnter={ () => this.setState({isHovered: true})}
                    onMouseLeave={ () => this.setState({isHovered: false})}
                    className={`${style.NavWrapper}`}>
                <div className={`${style.NavBtn} ${directionStyle}`} onClick={onClick}>
                    {arrow}
                </div>
            </div>
        } else {
            return null;
        }
    }
}

export default NavButton;



// WEBPACK FOOTER //
// ./routes/HelpDesk/NavButton/NavButton.js